import {
    SET_LAYOUT_SETTINGS_DATA_LOADING,
    SET_LAYOUT_SETTINGS_DATA,
    CLEAR_LAYOUT_SETTINGS_DATA,
} from "../actions/types";

const initialState = {
    isLoading: false,
    layoutSettingsData: [],
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_LAYOUT_SETTINGS_DATA_LOADING:
            return {
                ...state,
                isLoading: payload,
            };
        case SET_LAYOUT_SETTINGS_DATA:
            return {
                ...state,
                layoutSettingsData: Array.isArray(payload) ? [...payload] : [],
                isLoading: false,
            };
        default:
            return state;
    }
}
